import { createSlice } from '@reduxjs/toolkit';
import { getCookie } from '../../utils/utils';
import { RootState } from '../store';

const EMT_PALMA_COOKIE = 'EmtPalmaCookie';

// Define a type for the slice state
interface PermissionState {
  cookies: string;
  PermissionGeolocation: boolean;
  cookiesAnaliticas: boolean;
}

// Define the initial state using that type
const initialState: PermissionState = {
  cookies: (function getCookies() {
    const EmtPalmaCookie = getCookie(EMT_PALMA_COOKIE);
    return EmtPalmaCookie;
  })(),
  PermissionGeolocation: (function getLocation() {
    return localStorage.getItem('PermissionGeolocation') === 'true';
  })(),
  cookiesAnaliticas: (function getAnalitics() {
    return localStorage.getItem('cookiesAnaliticas') === 'true';
  })(),
};
export const permissionSlice = createSlice({
  name: 'permission',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateCookies: (state) => {
      document.cookie = EMT_PALMA_COOKIE + '=true';
      state.cookies = document.cookie;
    },

    updatePermissionGeolocation: (state, action) => {
      localStorage.setItem('PermissionGeolocation', action.payload);
      state.PermissionGeolocation = action.payload;
    },
    updateCookiesAnaliticas: (state, action) => {
      localStorage.setItem('cookiesAnaliticas', action.payload);
      state.cookiesAnaliticas = action.payload;
    },
  },
});

export const { updateCookies, updatePermissionGeolocation, updateCookiesAnaliticas } = permissionSlice.actions;

// Other code such as selectors can use the imported `PermissionState` type
export const permissionState = (state: RootState) => state.permission;
export const permissionCookiesState = (state: RootState) => state.permission.cookies;
export const permissionCookiesAnaliticasState = (state: RootState) => state.permission.cookiesAnaliticas;

export default permissionSlice.reducer;
